module.exports = __webpack_public_path__ + "img/d7.6afe95a7.png";